<!-- Une ligne de Mes graines (maquette 09) : quoi, combien il en reste, quand
     le semer chez soi, jusqu'à quand il se garde. -->
<div class="flex min-h-[72px] w-full cursor-pointer items-start gap-3 px-4 py-3">
  <span class="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-vw-surface-sunk">
    <vw-icon-svg
      [iconUrl]="imageUrl || '/assets/svg/tomato-3.svg'" fallback="plant"
      additionalClasses="h-14 w-14 object-cover"
      width="56px"
      height="56px"
    ></vw-icon-svg>
  </span>
  <div class="min-w-0 flex-1">
    <h3 class="text-body font-semibold text-vw-ink">{{ seed.cultivation?.name }}</h3>
    <p class="text-body-s text-vw-muted">{{ 'garden.tabs.seeds.seed-item.stock' | translate: { level: (seed.stockLevel | StockLevel) } }}</p>
    @if (timingLabel; as label) {
      <p class="text-body-s font-medium text-vw-primary-ink">{{ label.key | translate: label.params }}</p>
    }
    @if (seed.expirationDate) {
      @if (expired) {
        <p class="text-body-s font-semibold text-vw-danger">{{ 'garden.tabs.seeds.seed-item.expired' | translate: { date: (seed.expirationDate | vwDate: 'month') } }}</p>
      } @else {
        <p class="text-body-s text-vw-muted">{{ 'garden.tabs.seeds.seed-item.expiration' | translate: { date: (seed.expirationDate | vwDate: 'month') } }}</p>
      }
    }
  </div>
  <div class="flex shrink-0 items-center self-center">
    <!-- Action de la ligne (« Planter », « Semer ») ; sinon le chevron du détail -->
    <ng-content select="[seedAction]"></ng-content>
    @if (showChevron) {
      <vw-chevron-right-icon class="text-vw-muted"></vw-chevron-right-icon>
    }
  </div>
</div>
